import React from 'react';
import { withRouter } from 'react-router-dom';
import CadastroComprador from './components/cadastro-comprador-component';
import { dispatchLoadEvent } from '../metrics';

class CadastroCompradorContainer extends React.Component {
  componentDidMount() {
    dispatchLoadEvent('signUpPJ');
  }

  render() {
    return <CadastroComprador history={this.props.history} />;
  }
}

export default withRouter(CadastroCompradorContainer);
